angular.module('app').service('Alerts', ['FarmyNotifications', function (FarmyNotifications) {
  return FarmyNotifications;
}]);